import { TLCEventManager } from "../../../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../../../js/main/constants";
import { BaseResultTypeView } from "./BaseResultTypeView";

export class ListView extends BaseResultTypeView {
  constructor(options) {
    options = options || {};
    options.availabilityTemplate = "tmpl/results/listView_availability.html";
    options.resultsTemplate = "tmpl/results/listView_Results.html";
    options.viewName = "listView";

    super(options);
    this.viewSupportsRatings = true;

    this.addListeners();
  }
  // addEvents() {
  //   if (this.hasBoundEvents === false) {
  //     var _this = this;
  //     $("#" + this.id).on("click", ".request", function (event) {
  //       var index = parseInt($(event.currentTarget).attr("data-index"), 10);
  //       TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onRequest, {
  //         resource: _this.searchResponse.resources[index],
  //         referrer: "Results",
  //       });
  //       return false;
  //     });

  //     $("#" + this.id).on("click", ".eResource", function (event) {
  //       var index = parseInt($(event.currentTarget).attr("data-index"), 10);
  //       TLCEventManager.fireEvent(
  //         LS2PAC_CONSTANTS.Events.onAttemptEResourceCheckout,
  //         {
  //           resource: _this.searchResponse.resources[index],
  //           referrer: "Results",
  //         }
  //       );
  //       return false;
  //     });

  //     this.hasBoundEvents = true;
  //   }
  // }
}
